import { Text } from "./generated";

export const PlainText = (text: string): Text => ({
  Content: text,
  MarkUp: 'plaintext'
})

export const Html = (html: string): Text => ({
  Content: html,
  MarkUp: 'html'
})
